import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { arrayMove } from 'react-sortable-hoc';

import { Plus, Save, Trash } from 'lucide-react';
import { Badge, Button, ButtonIcon, Col, FormCard, Separator } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';

import { useNavigationStore } from '../../store';

import SortableList from './SortableList';

const propTypes = {
  data: PropTypes.object,
};

export default function NavigationCard({ data }) {
  const { reorder, collection: { useSubmit, deleteEntry }, collections: { list } } = useNavigationStore()
  const { handleSuccess, handleError } = useAppAlert()
  const handleSubmit = useSubmit()
  const [cmsNavItems, setCmsNavItems] = useState([])

  const { id, name, slug, cmsNavItems: items } = data

  useEffect(() => {
    setCmsNavItems(items)
  }, [])

  const handleSaveNavigation = async () => {
    try {
      await handleSubmit({ ...data, cmsNavItems })
      await list({})
      handleSuccess('Success', 'Navigation edited.')
    } catch {
      handleError('Error', 'Navigation was not saved.')
    }
  }

  const handleDeleteNavigation = async () => {
    try {
      await deleteEntry({ ...data, cmsNavItems })
      handleSuccess('Success', 'Navigation deleted.');
      await list({})
    } catch {
      handleError('Error', 'Navigation was not deleted.');
    }
  }

  const handleAddNavigationItem = () => {
    cmsNavItems.push({ label: "", url: "", order: "", nav_id: id })
    setCmsNavItems([...cmsNavItems])
  }

  const handleDeleteNavigationItem = idx => {
    const update = cmsNavItems.filter((_, index) => index !== idx)
    setCmsNavItems(update)
  }

  const handleChangeNavigationItem = (index, label, value) => {
    cmsNavItems[index][label] = value
    cmsNavItems[index]["order"] = index
    setCmsNavItems([...cmsNavItems])
  }

  const handleSortNavigationItem = newSort => {
    setCmsNavItems(newSort)
    reorder(newSort)
  }

  const getHelperDimensions = ({ node }) => ({
    height: node.offsetHeight,
    width: node.offsetWidth,
  })

  const shouldCancelStart = event => {
    const tag = event.target.tagName

    if (["path", "svg", "SPAN"].includes(tag)) {
      return false
    }

    return true
  }

  return <>
    <Col>
      <FormCard
        classNameBody='pt-0'
        className='relative'
        title={<div className='flex gap-2 items-center'>
          <span className='text-base-accent'>{name}</span>
          <Badge className='self-center' color='accent' variant='light'>{slug}</Badge>
        </div>}
        headerButtons={<div className='flex gap-2 twy-text-base items-center'>
          <ButtonIcon content="Delete" onClick={handleDeleteNavigation}>
            <Trash size={16} />
          </ButtonIcon>
          <ButtonIcon content="Save" onClick={handleSaveNavigation}>
            <Save size={16} />
          </ButtonIcon>
          <Separator orientation='vertical' className='py-3' />
          <Button onClick={handleAddNavigationItem} color="accent" size='sm'>
            <Plus size={16} />
            Add
          </Button>
        </div>}>
        <SortableList
          items={cmsNavItems}
          onSortEnd={handleSortNavigationItem}
          onChange={handleChangeNavigationItem}
          onDelete={handleDeleteNavigationItem}
          shouldCancelStart={shouldCancelStart}
          getHelperDimensions={getHelperDimensions}
        />
      </FormCard>
    </Col>
  </>
}

NavigationCard.propTypes = propTypes;
NavigationCard.defaultProps = {};
